import { useCurrentSubscription } from './useCurrentOrganization';
import { SubscriptionStatus } from 'redux/reducers/authReducer';

export function useIsReadOnly() {
  const currentSubscription = useCurrentSubscription();

  if (currentSubscription.status === SubscriptionStatus.Unsubscribed && currentSubscription.daysFreeTrialLeft <= 0) {
    return true;
  }

  return false;
}
